/** Shared spiritual / learning service copy used on Home and Classes pages.
 *  Promo blocks (Telegram bot, Zimare app) live only on the homepage —
 *  keep `description` free of adverts so Classes tabs stay clean.
 */
const spiritualServices = {
  "en": {
    "teachings": {
      "title": "Orthodox Teachings",
      "description": "We teach the national Sunday School curriculum (Church rituals, holy books, Christian ethics, Ge'ez, foundations of faith, and Church history) from pre-school to 12th grade. We also provide Christian training to help students fulfill their social responsibilities.",
      "botLinkText": "Open Telegram Bot"
    },
    "hymnody": {
      "title": "Hymnody Lessons",
      "description": "We teach daily and holiday hymns, poetic chants, and Yaredic Wereb (hymns) sung in the Holy Church, along with traditional Shibsheba (liturgical dance) and Kebero (drum) lessons that preserve our Church's rich heritage."
    },
    "instruments": {
      "title": "Orthodox Musical Instrument Training",
      "description": "Begena, Kirar, and Masenqo traditional instrument classes are offered every Monday to Saturday, taught by experienced teachers.\n\n• Morning Session: 6:00 AM - 8:30 AM (12:00 - 2:30 Local)\n• Evening Session: 4:00 PM - 7:30 PM (10:00 - 1:30 Local)"
    },
    "library": {
      "title": "Library Services",
      "description": "Our Sunday School library, located within the compound of Debre Efrata Kidist Dingil Mariam Cathedral, offers a wide collection of theological, liturgical, and worship books. You will find hagiographies, spiritual fiction, contemporary translations, and profound commentaries passed down from early church scholars. We also provide service and hymnody books, available in both digital (soft copy) and physical (hard copy) formats.\n\n• Working Days: Sunday to Sunday (Closed on Thursdays)\n• Morning Session: 8:30 AM - 12:00 PM (2:30 - 6:00 Local)\n• Afternoon Session: 2:00 PM - 7:00 PM (8:00 - 1:00 Local)\n• For more information, call 0934426846."
    },
    "media": {
      "title": "Media Services",
      "description": "Capture your sacred moments forever. Our media team offers professional photo and video packages for all special events, preserving high-quality memories for a lifetime.\n\n• Baptism and Christening\n• Mediation and Marriage\n• Special Occasions\n• For more information, call 0903896637.",
      "learnMore": "Click to learn more",
      "contact": "For more information, call 0903896637."
    },
    "promoButton": "Google Play"
  },
  "am": {
    "teachings": {
      "title": "ኦርቶዶክሳዊ ትምህርቶች",
      "description": "በሀገር አቀፍ ደረጃ ከጠቅላይ ቤተ ክህነት በሁሉም ሰንበት ትምህርት ቤቶች እንዲተገበር የወጣውን አዲሱን ሥርዓተ ትምህርት (ሥርዓተ ቤተ ክርስቲያን፣ ክርስቲያናዊ ሥነ ምግባር፣ ቅዱሳት መጻሕፍት ጥናት፣ መሠረተ ሃይማኖት እና የቤተ ክርስቲያን ታሪክ) ከቅድመ መደበኛ (ኬጂ) እስከ 12ኛ ክፍል ድረስ እያስተማርን እንገኛለን። እንዲሁም ያሉበትን የሕይወት ሁኔታ፣ ኃላፊነት እና ወቅታዊ ፈተናዎችን እና ጉዳዮችን እንዴት በክርስቲያናዊ ሕይወት መወጣት እንደሚገባ የሚያስተምሩ ኦርቶዶክሳዊ ሥልጠናዎችን ከሰንበት ትምህርት ቤታችን ያገኛሉ።",
      "botLinkText": "ቴሌግራም ቦት ይክፈቱ"
    },
    "hymnody": {
      "title": "ትምህርተ ዝማሬ",
      "description": "በየዕለቱ የሚዘመሩ የዘወትር ዝማሬዎችን፣ አጭር የወረብ ዝማሬዎችን፣ የግጥም ዝማሬዎችን እና ያሬዳዊ ወረብ ዝማሬዎችን፣ እንዲሁም የቤተ ክርስቲያናችንን ትውፊት የጠበቀ የሽብሸባ እና የከበሮ ጥናት ትምህርቶችን እናስተምራለን።"
    },
    "instruments": {
      "title": "ኦርቶዶክሳዊ የዜማ መሳሪያ ሥልጠና",
      "description": "በቤተክርስቲያናችን በአገልግሎት ላይ ያሉ የበገና፣ ክራር እና ማሲንቆ የዜማ መሳሪያ ትምህርቶችን ልምዱ ባላቸው መምህራን ዘወትር ከሰኞ እስከ ቅዳሜ እንሰጣለን።\n\nየክፍለ ጊዜ ሰዓታት፦\n\n• ጠዋት፦ ከ 12፡00 - 2፡30\n• ማታ፦ ከ 10፡00 - ምሽቱ 1፡30"
    },
    "library": {
      "title": "የቤተ መጻሕፍት አገልግሎት",
      "description": "በደብረ ኤፍራታ ቅድስት ድንግል ማርያም ካቴድራል ግቢ ውስጥ የሚገኘው የሰንበት ትምህርት ቤታችን ቤተ-መጻሕፍት፤ ሰፊ የሆኑ የነገረ-መለኮት፣ የሥርዓተ-ቤተክርስቲያን እና የአምልኮ መጻሕፍት ስብስብን አዘጋጅቶ ይጠብቆታል። በቤተ-መጻሕፍታችን የቅዱሳን ገድላትና ድርሳናት፣ መንፈሳዊ ልብ ወለዶች፣ ወቅታዊ የትርጉም ሥራዎች፣ እንዲሁም ከቀደምት የቤተክርስቲያን ሊቃውንት ሲወርድ ሲዋረድ የመጡ ጥልቅ የትርጓሜ መጻሕፍትን ያገኛሉ። በተጨማሪም የተለያዩ የአገልግሎት እና የዜማ መጻሕፍትን በህትመት (hard copy) እና በዲጂታል (soft copy) መልክ አቅርበናል።\n\nየአገልግሎት ቀናት እና ሰዓታት፦\n\n• የአገልግሎት ቀናት፦ ከእሁድ እስከ እሁድ (ሐሙስ ዝግ ነው)\n• የጠዋት ክፍለ ጊዜ፦ ከ 2፡30 - 6፡00\n• ከሰዓት በኋላ ክፍለ ጊዜ፦ ከ 8፡00 - ምሽቱ 1፡00\n• ለበለጠ መረጃ በ 0934426846 ይደውሉ።"
    },
    "media": {
      "title": "የሚዲያ አገልግሎቶች",
      "description": "ቅዱስ ጊዜያችሁን ለዘላለም ያዙ። የእኛ የሚዲያ ቡድን ለሁሉም ልዩ ዝግጅቶች ሙያዊ የፎቶ እና የቪዲዮ ፓኬጆችን ያቀርባል፣ ይህም ለህይወት ዘመን የሚቆዩ ከፍተኛ ጥራት ያላቸውን ትዝታዎች ያስቀምጣል\n\n• ጥምቀት እና ክርስትና\n• ሽምግልና እና ጋብቻ\n• ልዩ ልዩ ዝግጅቶች\n• ለበለጠ መረጃ በ 0903896637 ይደውሉ።",
      "learnMore": "የበለጠ ለማወቅ ይጫኑ",
      "contact": "ለበለጠ መረጃ በ 0903896637 ይደውሉ።"
    },
    "promoButton": "Google Play"
  },
  "ge": {
    "teachings": {
      "title": "ትምህርተ ኦርቶዶክስ",
      "description": "እምጠቅላይ ቤተ ክህነት በሀገር አቀፍ ደረጃ ለኵሉ ቤተ ትምህርት ሰንበት ዘወፅአ ሐዲስ ሥርዓተ ትምህርት (ሥርዓተ ቤተ ክርስቲያን፣ ክርስቲያናዊ ሥነ ምግባር፣ ቅዱሳት መጻሕፍት ጥናት፣ መሠረተ ሃይማኖት ወታሪከ ቤተ ክርስቲያን) እምቅድመ መደበኛ (ኬጂ) እስከ ፲፪ ክፍል ንሕነ ንመሀር። ወከማሁ ኦርቶዶክሳዊ ሥልጠና ዘየመሀር ከመ ይወጽኡ ኅላዌ ሕይወቶሙ ወኃላፊነቶሙ ወፈተናተ ዘመን በክርስቲያናዊ ሕይወት እምቤተ ትምህርት ሰንበትነ ትረክቡ።",
      "botLinkText": "ቴሌግራም ቦት ክፈቱ"
    },
    "hymnody": {
      "title": "ትምህርተ ዝማሬ",
      "description": "ንሕነ ንመሀር ዝማሬያተ ዘወትር ወወረባተ ንኡሳነ ወዝማሬያተ ግጥም ወያሬዳዊ ወረብ፤ ወከማሁ ትምህርተ ሽብሸባ ወከበሮ ዘየዐቅብ ትውፊተ ቤተ ክርስቲያንነ።"
    },
    "instruments": {
      "title": "ሥልጠነ መሳርያተ ዜማ ኦርቶዶክስ",
      "description": "ትምህርተ በገና ወክራር ወማሲንቆ ዘውስተ አገልግሎተ ቤተ ክርስቲያንነ በመምህራን ልሙዳን እምሰኑይ እስከ ቀዳም ንሕነ ንህብ።\n\nሰዓታተ ክፍለ ጊዜ፦\n\n• ነግህ፦ እም ፲፪፡፻ - ፪፡፴\n• ሌሊት፦ እም ፲፡፻ - ፩፡፴ ዘምሴት"
    },
    "library": {
      "title": "አገልግሎተ ቤተ መጻሕፍት",
      "description": "ቤተ መጻሕፍት ዘቤተ ትምህርት ሰንበትነ፣ ዘይረከብ ውስተ ዐጸደ ካቴድራል ደብረ ኤፍራታ ቅድስት ድንግል ማርያም፣ ያቀርብ ብዙኃነ መጻሕፍተ ነገረ ሃይማኖት፣ ሥርዓተ ቤተ ክርስቲያን ወአምልኮ። ትረክቡ ገድላተ ወድርሳናተ፣ ልብወለደ መንፈሳዊ፣ ትርጓሜያተ ዘመናውያነ፣ ወዓሚቀ ትርጓሜ ዘተመኃለፈ እምቀደምት ሊቃውንተ ቤተ ክርስቲያን። ከማሁኒ ናቀርብ መጻሕፍተ አገልግሎት ወዜማ በሕትመት ወበዲጂታል።\n\nመዋዕለ አገልግሎት ወሰዓታት፦\n\n• መዋዕለ አገልግሎት፦ እምእሁድ እስከ እሁድ (ሐሙስ ዕፁው)\n• ዘነግህ፦ እም ፪፡፴ - ፮፡፻\n• ዘድሕረ ቀትር፦ እም ፰፡፻ - ፩፡፻ ዘምሴት\n• ለበለጠ መረጃ በ 0934426846 ይደውሉ።"
    },
    "media": {
      "title": "አገልግሎተ ሚድያ",
      "description": "አኀዙ ቅዱሳተ ጊዜያቲክሙ ለዓለም። ጉባኤ ሚድያነ ያቀርብ ሙያዊ ፎቶ ወቪድዮ ለኵሉ ልዩ ዝግጅት፣ ከመ የኅድግ ተዝካረ ልዑል ጽሬት ለዘመነ ሕይወት።\n\n• ጥምቀት ወክርስትና\n• ሽምግልና ወመርዓ\n• ልዩ ልዩ ዝግጅታት\n• ለበለጠ መረጃ በ 0903896637 ይደውሉ።",
      "learnMore": "ለተወሳኺ ይጽቀጡ",
      "contact": "ለበለጠ መረጃ በ 0903896637 ይደውሉ።"
    },
    "promoButton": "አውርድ"
  }
};

export function getSpiritualServices(language = 'en') {
  return spiritualServices[language] || spiritualServices.en;
}

export default spiritualServices;
